import React from 'react';
import S from './Image.styled';
import { IAsset } from '@/src/types';
import { modifyImage } from '@/src/helpers/modifyImage';

type Props = {
  image: IAsset;
  height?: string | number;
  width?: string | number;
  widthDesktop?: string | number;
  maxWidth?: string | number;
  maxHeight?: string | number;
  minHeight?: string | number;
  margin?: string | number;
  radius?: string | number;
  aspectRatio?: string;
  mobileAspectRatio?: string;
  overlay?: boolean;
  style?: React.CSSProperties;
  size?: string;
  desktopAspectRatio?: string;
};

const Image: React.FC<Props> = ({
  image,
  height,
  width,
  widthDesktop,
  maxWidth,
  maxHeight,
  minHeight,
  margin,
  radius,
  overlay,
  aspectRatio,
  mobileAspectRatio,
  style,
  size,
  desktopAspectRatio,
}) => {
  const modImage = modifyImage(image, size as 'string' | undefined);

  return (
    <S.Image
      src={modImage}
      alt={image?.alt || ''}
      $height={height}
      $width={width}
      $widthDesktop={widthDesktop}
      $maxWidth={maxWidth}
      $maxHeight={maxHeight}
      $minHeight={minHeight}
      $radius={radius}
      $margin={margin}
      $aspectRatio={aspectRatio}
      $mobileAspectRatio={mobileAspectRatio}
      style={style}
      $desktopAspectRatio={desktopAspectRatio}
    >
      {overlay && <S.Overlay />}
    </S.Image>
  );
};

export default Image;
